import { Box, Flex, Text, HStack, IconButton, Menu, MenuButton } from '@chakra-ui/react';
import { DragHandleIcon } from '@chakra-ui/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { SortableMenuItemProps } from './types';
import { LuMoreVertical, LuEye, LuEyeOff } from 'react-icons/lu';
import ColumnActions from './column-actions';


export function SortableMenuItem({
  id,
  column,
  isVisible,
  onToggleVisibility,
  onEdit,
  onDelete,
}: SortableMenuItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      px={2}
      py={1}
      _hover={{ bg: 'gray.100' }}
      borderRadius="md"
      cursor="pointer"
    >
      <Flex justify="space-between" align="center" w="100%">
        <HStack spacing={2}>
          <IconButton
            {...attributes}
            {...listeners}
            aria-label="Drag handle"
            icon={<DragHandleIcon />}
            size="xs"
            variant="ghost"
            cursor="grab"
          />
          <Text fontSize="sm">{column.title}</Text>
        </HStack>
        <HStack spacing={2}>
          <IconButton
            aria-label={isVisible ? "Hide column" : "Show column"}
            icon={isVisible ? <LuEye /> : <LuEyeOff />}
            variant="secondary"
            onClick={(e) => {
              e.stopPropagation();
              onToggleVisibility();
            }}
          />
          <Menu>
            <MenuButton
              as={IconButton}
              icon={<LuMoreVertical />}
              variant="secondary"
              onClick={(e) => e.stopPropagation()}
            />
            <ColumnActions
              onEdit={onEdit}
              onDelete={onDelete}
            />
          </Menu>
        </HStack>
      </Flex>
    </Box>
  );
} 